<template>
  <div class="editgroup-form">
    <el-dialog title="修改分组" :visible="dialogFormVisible" width="1200px" :show-close="false" @open="dialogOpen">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline="true">
        <el-form-item label="分组名称" label-width="100px" prop="groupName">
          <el-input v-model="ruleForm.groupName" autocomplete="off" placeholder="请输入分组名称"
            style="width: 235px"></el-input>
        </el-form-item>
        <el-form-item label="分组类型" label-width="100px" prop="groupType">
          <el-select v-model="ruleForm.type" placeholder="请选择" @change="groupTypeSelect">
            <el-option v-for="item in groupTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :model="ruleForm" :rules="rules" ref="ruleFormO" :inline="true" v-if="preparationSelectShow">
        <el-form-item label="年级列表" label-width="100px" prop="grade">
          <!-- 选择年级 -->
          <el-select v-model="ruleForm.gradeId" placeholder="请选择年级">
            <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName"
              :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目列表" label-width="100px" prop="course">
          <el-select v-model="ruleForm.courseId" placeholder="请选择">
            <el-option v-for="item in courseList" :key="item.id" :label="item.courseName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent>
        <el-form-item label="教师搜索" label-width="100px">
          <div class="search">
            <search :placeholder="placeholder" @search="search" />
          </div>
        </el-form-item>
      </el-form>
      <div class="table-list">
        <div class="table-item">
          <div>选择分组成员：</div>
          <el-table ref="table" :data="teacherList" :row-key="getRowKeys" style="width: 100%; " height="350px"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column prop="teacherName" label="姓名">
            </el-table-column>
            <el-table-column prop="teacherNumber" label="编号">
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label="操作" width="130px">
              <template slot-scope="scope">
                <div class="handle-container" v-show="leaderId !== scope.row.id &&
                  leaderBtnShowList.includes(scope.row.id)
                  ">
                  <!-- 修改 -->
                  <el-button type="primary" @click="editLeader(scope.row)">
                    设为组长
                  </el-button>
                </div>
                <div v-show="leaderId == scope.row.id">组长</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-item">
          <div>已选择分组成员：</div>
          <el-table :data="selectList" style="width: 100%" height="350px">
            <el-table-column prop="teacherName" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="teacherNumber" label="编号" width="180">
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="form-btn">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  name: "",
  props: [
    "dialogFormVisible",
    "teacherList",
    "groupInfo",
    "groupTypeList",
    "gradeSelectList",
    "courseList",
  ],
  components: {
    search,
  },
  data() {
    return {
      placeholder: "请输入教师姓名",
      ruleForm: {
        groupName: "",
        type: "0",
        gradeId: "",
        courseId: "",
      },
      rules: {
        groupName: [
          { required: true, message: "请输入分组名字", trigger: "blur" },
        ],
      },
      groupDetail: null,
      list: [],
      leaderId: "",
      indexArray: [],
      leaderBtnShowList: [],
      preparationSelectShow: false,
      selectList: []
    };
  },
  inject: ["refresh"],
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    search(query) {
      this.$emit("searchTeacher", query);
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
    },
    groupTypeSelect(e) {
      // console.log("type==>", this.ruleForm.type);
      this.preparationSelectShow = e == 1 ? true : false;
    },
    getGroupDetail() {
      this.leaderBtnShowList = [];
      this.get(this.$url.getTeacherGroup + "/" + this.groupInfo.id).then(
        (res) => {
          // console.log("当前分组详情==>", res);
          this.groupDetail = res.data;
          this.ruleForm.groupName = this.groupDetail.crowdName;
          this.ruleForm.type = "" + this.groupDetail.type;
          this.leaderId = this.groupDetail.leaderId;
          this.preparationSelectShow =
            this.groupDetail.type == 1 ? true : false;
          this.ruleForm.gradeId = this.groupDetail.gradeId;
          this.ruleForm.courseId = this.groupDetail.courseId;

          // 将返回的分组成员转换，然后将对应的教师列表切换为选中状态
          this.indexArray = this.groupDetail.teacherCrowdList
            .map((obj) =>
              this.teacherList.findIndex((item) => item.id === obj.teacherId)
            )
            .filter((index) => index !== -1);

          // this.selectTeacherList = this.teacherList.filter(item => this.groupDetail.teacherCrowdList.includes(item));

          this.indexArray.forEach((index) => {
            if (index !== -1) {
              this.$refs.table.toggleRowSelection(
                this.teacherList[index],
                true
              );
            }
          });

          // 显示组长切换按钮的成员列表数据（必须已经是分组成员且当前不是组长
          const selectTeacherList = this.teacherList.filter((obj) => {
            return this.groupDetail.teacherCrowdList.some(
              (item) => item.teacherId === obj.id
            );
          });
          selectTeacherList.map((item) => {
            this.leaderBtnShowList.push(item.id);
          });
          this.leaderBtnShowList = [...new Set(this.leaderBtnShowList)];
        }
      );
    },
    // 关闭弹出窗口
    dialogClose() {
      this.reset();
      this.$emit("update:dialogFormVisible", false);
    },
    dialogOpen() {
      this.getGroupDetail();
    },
    editLeader(data) {
      this.$confirm("是否将该成员设置为组长?", "修改组长", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.leaderId = data.id;
        })
        .catch(() => { });
    },
    confirm() {
      // console.log("type==>", this.ruleForm.type);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // this.$emit("formSubmit", this.ruleForm);

          this.selectList.forEach((item) => {
            // console.log("item==>", item);
            this.list.push(item.id);
          });
          // console.log("this.list==>", this.list);

          this.put(this.$url.editTeacherGroup, {
            id: this.groupDetail.id,
            type: +this.ruleForm.type,
            gradeId: this.ruleForm.gradeId,
            courseId: this.ruleForm.courseId,
            crowdName: this.ruleForm.groupName,
            leaderId: this.leaderId,
            schoolId: this.user.schoolId,
            teacherList: this.list, //教师id列表
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              // 刷新列表
              this.refresh();
              this.reset();
              // 关闭弹出框
              this.dialogClose();
            } else {
              this.$message.error("修改失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm.groupName = "";
      this.list = [];
      this.selectTeacherList = [];
      this.$refs.table.clearSelection();
      // this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./editgroup-info.scss";
</style>